

import { eggStartParty } from './eggs/party';

export const consoleSearch = (query: string) => {
    if (query.endsWith('>>')) {
        const command = query.substr(0, query.length - 2);

        if (command.startsWith('!')) {
            const app = command.substr(1);
            window.open('/#!' + app, '_self');
            window.location.reload();
            return Promise.resolve(true);
        }

        if (command.startsWith(':')) {
            const shortCommand = command.substr(1);
            if (shortCommand === 'party') {
                eggStartParty();
                return Promise.resolve(true);
            }
        }
    }

    return Promise.resolve(false);
};


import { eggStartParty } from './eggs/party';

export const consoleSearch = (query: string) => {
    if (query.endsWith('>>')) {
        const command = query.substr(0, query.length - 2);

        if (command.startsWith('!')) {
            const app = command.substr(1);
            window.open('/#!' + app, '_self');
            window.location.reload();
            return Promise.resolve(true);
        }

        if (command.startsWith(':')) {
            const shortCommand = command.substr(1);
            if (shortCommand === 'party') {
                eggStartParty();
                return Promise.resolve(true);
            }
        }
    }

    return Promise.resolve(false);
};
